import React, { useEffect, useState } from 'react';
export function useCountdown(initialHours = 23, initialMinutes = 58, initialSeconds = 31) {
  const [time, setTime] = useState(initialHours * 3600 + initialMinutes * 60 + initialSeconds);
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const h = Math.floor(time / 3600);
  const m = Math.floor(time % 3600 / 60);
  const s = time % 60;
  return {
    hours: h.toString().padStart(2, '0'),
    minutes: m.toString().padStart(2, '0'),
    seconds: s.toString().padStart(2, '0')
  };
}
export function CountdownDisplay() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="flex items-center justify-center space-x-2 text-2xl md:text-4xl font-bold font-sans tracking-widest" data-id="element-50">
      <div className="bg-bgHero text-headlineLight px-3 py-2 rounded-lg border border-ctaFrom shadow-[0_0_20px_rgba(192,132,252,0.5)]" data-id="element-51">
        {hours}
      </div>
      <span className="text-accentText" data-id="element-52">:</span>
      <div className="bg-bgHero text-headlineLight px-3 py-2 rounded-lg border border-ctaFrom shadow-[0_0_20px_rgba(192,132,252,0.5)]" data-id="element-53">
        {minutes}
      </div>
      <span className="text-accentText" data-id="element-54">:</span>
      <div className="bg-bgHero text-headlineLight px-3 py-2 rounded-lg border border-ctaFrom shadow-[0_0_20px_rgba(192,132,252,0.5)]" data-id="element-55">
        {seconds}
      </div>
    </div>;
}